module.exports = __webpack_public_path__ + "static/media/covid19CDCLogo.b15fe758.png";